import { TEditModifierGroupAction, EditModifierGroupActionTypes } from './editModifierGroupActions';
import { IEditModifierGroupState } from './editModifierGroupContext';

export const editModifierGroupReducer = (
	state: IEditModifierGroupState,
	action: TEditModifierGroupAction,
): IEditModifierGroupState => {
	switch (action.type) {
		case EditModifierGroupActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditModifierGroupActionTypes.SET_ALL_DATA:
			return {
				...state,
				modifierGroupID: action.payload.modifierGroupID,
				initialIDSelectedCustomer: action.payload.initialIDSelectedCustomer,
				initialIDsSelectedRestaurant: action.payload.initialIDsSelectedRestaurant,
				nameOfModifierGroup: action.payload.nameOfModifierGroup,
				externalId: action.payload.externalId,
				articleNumber: action.payload.articleNumber,
				translations: action.payload.translations,
			};
		case EditModifierGroupActionTypes.CHANGE_LOADER_STATUS:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case EditModifierGroupActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case EditModifierGroupActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
			};
		case EditModifierGroupActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditModifierGroupActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case EditModifierGroupActionTypes.CHANGE_NAME_OF_MODIFIER_GROUP:
			return {
				...state,
				nameOfModifierGroup: action.payload.nameOfModifierGroup,
			};
		case EditModifierGroupActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case EditModifierGroupActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditModifierGroupActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditModifierGroupActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditModifierGroupActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditModifierGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
